import React, { useState, useEffect, useRef, useCallback } from "react";
import {Col , ProgressBar , Form , Button} from "react-bootstrap";
import Sound from 'react-sound';
import { base, s3base } from "api.js";
import ReusableRecorder from "components/Recorder/ReusableRecorder.jsx";
import NoMicrophone from "views/NoMicrophone.jsx";
import PlaybackSpeedBtns from "components/PracticeMaterial/PlaybackSpeedBtns.jsx";
import stopImage from "assets/images/stop recording.png";
import grayImage from "assets/images/gray circle.png";
import "components/custom.css";
import MicWaveform from "components/Question/Speaking/MicWaveform";
import { formatTimeMiliSecond } from "util/helper.js";
import { isIOSDevice } from 'util/deviceDetection';
import useBeep from 'components/BeepSound';
import IOSAudioPlayer from "components/Question/Speaking/New/IOSAudioPlayer.jsx";
import Beep from "Beep.js";

// import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
// import getBlobDuration from 'get-blob-duration';
// import SpeechToText from "components/Question/Speaking/New/SpeechToText";

const RetellLec = (props) => {
  const [isRecording, setIsRecording] = useState(false);
  const [blobURL, setBlobURL] = useState('');
  const [isBlocked, setIsBlocked] = useState(false);
  const [secondCount, setSecondCount] = useState(isIOSDevice() ? 2 : 8);
  const [duration, setDuration] = useState(0);
  const [secondCount2, setSecondCount2] = useState(10);
  const [recordCount, setRecordCount] = useState(0);
  const [recordId, setRecordId] = useState(1);
  const [intervalId, setIntervalId] = useState(0);
  const [intervalId2, setIntervalId2] = useState(0);
  const [questionId, setQuestionId] = useState("");
  const [reset, setReset] = useState(false);
  const [soundStatus, setSoundStatus] = useState(true);
  const [soundPer, setSoundPer] = useState(0);
  const [trans, setTrans] = useState('');
  const [volume, setVolume] = useState(100);
  const [correctFlag, setCorrectFlag] = useState(true);
  const [beepStatus, setBeepStatus] = useState(false);
  const [file, setFile] = useState('');
  const [playbackSpeed, setPlaybackSpeed] = useState(1);
  const [soundKey, setSoundKey] = useState(0);
  const [secondCount2Bckup, setSecondCount2Bckup] = useState(0);
  const [saveTranscript, setSaveTranscript] = useState(false);
  const [remainingTime, setRemainingTime] = useState("00:00");
  const [recordingTimeLeft, setRecordingTimeLeft] = useState(40);
  // const [question, setQuestion] = useState("");
  // const [position, setPosition] = useState(0);
  
  const reusableRecorderRef = useRef(null);
  const recordingIntervalRef = useRef(null);
  const beepPlayedRef = useRef(false);
  const submittedRef = useRef(false);
  const handleRecordingCompleteRef = useRef(null);

  const LIMIT = 40;
  const { playBeep } = useBeep({ frequency: 800, duration: 300, volume: 0.3 });

  useEffect(() => {
    if (!props.answer) {
      const id = setInterval(timer, 1000);
      setIntervalId(id);
    }

    // navigator.mediaDevices.getUserMedia({ audio: true }).then(() => {
    //   setIsBlocked(false);
    // }).catch(() => {
    //   setIsBlocked(true);
    // });
    if (!props.resultMode) {
      navigator.mediaDevices.getUserMedia({ audio: true },
        () => {
          setIsBlocked(false);
        }, () => {
          setIsBlocked(true);
        },
      );
    } else {
      setIsBlocked(false);
    }

    return () => {
      clearInterval(intervalId);
      if (recordingIntervalRef.current) {
        clearInterval(recordingIntervalRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (props.data) {
      if ((questionId && questionId !== props.data.id) || props.restart) {
        clearInterval(intervalId);
        clearInterval(intervalId2);
        clearInterval(recordId);
        if (recordingIntervalRef.current) {
          clearInterval(recordingIntervalRef.current);
        }

        setCorrectFlag(true);
        setRecordCount(0);
        setSoundPer(0);
        setIsRecording(false);
        setSecondCount(isIOSDevice() ? 2 : 8);
        setSecondCount2(10);
        setQuestionId(props.data.id);
        setBlobURL('');
        setReset(true);
        setTrans('');
        setSoundStatus(true);
        setIntervalId2(0);
        setDuration(0);
        setRecordingTimeLeft(40);
        beepPlayedRef.current = false;
        submittedRef.current = false;
      } else {
        if (!questionId) {
          setCorrectFlag(true);
          setQuestionId(props.data.id);
        }
      }
    }
  }, [props.data, props.restart]);

  const startRecordingNow = useCallback(() => {
      if (isBlocked) return;
  
      if (reusableRecorderRef.current) {
        reusableRecorderRef.current.startRecording();
      }
    }, [isBlocked]);

  const startRecording = () => {
    if (isBlocked) {
      return;
    }

    if (!beepPlayedRef.current) {
      // setBeepStatus(true);
      beepPlayedRef.current = true;
      // Start recording immediately when beep begins so no audio is missed
      startRecordingNow();
      setBeepStatus(true);
    }
  };

  const handleBeepFinishedPlaying = () => {
    setBeepStatus(false);
    
    // if (isBlocked) {
    //   return;
    // }

    // if (reusableRecorderRef.current) {
    //   reusableRecorderRef.current.startRecording();
    // }
  };

  const handlePlayBeep = useCallback(() => {
    playBeep({
    onStart: () => {
      setBeepStatus(true);
      // Start recording immediately when beep begins so no audio is missed
      startRecordingNow();
    },
    onComplete: () => {
      // handleBeepFinishedPlaying();
       setBeepStatus(true);
    },
    onError: (error) => {
      console.error('Beep failed:', error);
      // handleBeepFinishedPlaying();
      setBeepStatus(false);
    }
    });
  }, [playBeep, startRecordingNow]);

  useEffect(() => {
    if (isIOSDevice() && beepStatus) {
      handlePlayBeep();
    }
  }, [beepStatus, playBeep, isIOSDevice]);

  const stopRecording = async () => {
    if (reusableRecorderRef.current && isRecording) {
      reusableRecorderRef.current.stopRecording();
    }
  };

  const setTransFunc = (a) => {
    if (trans != a) {
      setTrans(a);
    }
  };

  const stopTest = async () => {
    if (submittedRef.current) return;
    
    console.log('stopTest called, isRecording:', isRecording);
    
    if (reusableRecorderRef.current && isRecording) {
      submittedRef.current = true;
      reusableRecorderRef.current.stopRecording();
    } else {
      console.log('Calling nextQuestion with existing data');
      submittedRef.current = true;
      props.nextQuestion({
        data: file,
        audio_text: trans,
        duration: duration
      });
    }
  };

  const updateCorrect = () => {
    props.submit({ 'data': '', audio_text: '', duration: 0 });
    setCorrectFlag(false);
  };

  const timer = () => {
    setSecondCount(prevCount => {
      if (prevCount === 0) {
        clearInterval(intervalId);
        return 0;
      } else {
        return prevCount - 1;
      }
    });
  };

  const timer1 = () => {
    setSecondCount2(prevCount => {
      if (prevCount === 1) {
        clearInterval(intervalId2);
        startRecording();
        setSoundStatus(false);
        return 0;
      } else {
        return prevCount - 1;
      }
    });
  };

  const handleSongPlaying = (obj) => {
    setSoundPer(obj.position * 100 / obj.duration);
    setRemainingTime(formatTimeMiliSecond(obj.duration - obj.position));
  };

  const handleSongFinishedPlaying = () => {
    setSoundStatus(false);
    props.soundChecked();

    const id = setInterval(timer1, 1000);
    setIntervalId2(id);
    setSecondCount2(10);
    setSecondCount2Bckup(10);
  };

  const stopAudio = () => {
    setSoundStatus(false);
    setSecondCount2(10);
  };

  const skip = () => {
    clearInterval(intervalId);
    setSecondCount(0);
  };

  const changeRange = (e) => {
    setVolume(e.target.value);
  };

  const loadingSound = (obj) => {
    // Intentionally empty
  };

  const changePlaybackSpeed = (speed) => {
    if (speed !== playbackSpeed) {
      let seconds = secondCount2Bckup;
      if (secondCount === 0) {
        if (speed === 2 || speed === 1.5) {
          seconds = seconds / speed;
        }
      }
      setSoundKey(prevKey => prevKey + 1);
      setPlaybackSpeed(speed);
      setSecondCount2(Math.round(seconds));
    }
  };

  const setSaveTranscriptFunc = (status) => {
    setSaveTranscript(status);
  };

  const setTranscriptFunc = (transcript) => {
    setTrans(transcript);
    setSaveTranscript(false);

    const data_to_send = {
      data: file,
      audio_text: transcript,
      duration: duration
    };

    if (props.testMode) {
      props.nextQuestion(data_to_send);
    } else {
      props.submit(data_to_send, true);
      props.showResult();
    }
  };

  useEffect(() => {
    if (reset) {
      const id = setInterval(timer, 1000);
      setIntervalId(id);
      setReset(false);
      setRecordingTimeLeft(40);
      beepPlayedRef.current = false;
    }
  }, [reset]);

  useEffect(() => {
    if (props.stopRecording) {
      stopTest();
    }
  }, [props.stopRecording]);

  let questionText = "";
  if (props.restart) {
    props.restartQue();
  }
  if (props.data) {
    if (correctFlag) {
      updateCorrect();
    }
    questionText = props.data.question;
  }

  if (isBlocked) {
    return (<NoMicrophone />);
  }

  const handleRecordingComplete = (recordingData) => {
    if (recordingIntervalRef.current) {
      clearInterval(recordingIntervalRef.current);
      recordingIntervalRef.current = null;
    }

    setBlobURL(recordingData.url);
    setFile(recordingData.file);
    setDuration(recordingData.duration);
    setIsRecording(false);
    setSaveTranscript(true);
    setRecordCount(100);
    setTrans(recordingData.transcript);
    
    if (isIOSDevice() && !submittedRef.current) return;

    const data_to_send = {
      data: recordingData.file,
      audio_text: recordingData.transcript,
      duration: recordingData.duration
    };

    if (props.testMode) {
      props.nextQuestion(data_to_send);
    } else {
      props.submit(data_to_send, true);
      props.showResult();
    }
  };

  const handleRecordingStart = () => {
    setIsRecording(true);
    setBlobURL('');
    setRecordCount(0);
    setRecordingTimeLeft(40);
    
    // Start timer that increments recordCount every second
    if (recordingIntervalRef.current) {
      clearInterval(recordingIntervalRef.current);
    }
    
    recordingIntervalRef.current = setInterval(() => {
      setRecordCount((prevCount) => {
        const newCount = prevCount + 1;
        
        // Update time left
        const timeLeft = Math.max(LIMIT - newCount, 0);
        setRecordingTimeLeft(timeLeft);
        
        // Stop recording when we reach 40 seconds
        if (newCount >= LIMIT + 1) {
          clearInterval(recordingIntervalRef.current);
          recordingIntervalRef.current = null;
          // Force stop the recording
          if (reusableRecorderRef.current) {
            reusableRecorderRef.current.stopRecording();
          }
          return LIMIT; // Cap at 40
        }
        
        return newCount;
      });
    }, 1000);
  };

  const handleRecordingStop = () => {
    if (recordingIntervalRef.current) {
      clearInterval(recordingIntervalRef.current);
      recordingIntervalRef.current = null;
    }
    setIsRecording(false);
  };

  handleRecordingCompleteRef.current = handleRecordingComplete;
    
  const stableHandleRecordingComplete = useCallback((data) => {
    handleRecordingCompleteRef.current(data);
  }, []);

  return (
    <>
      <ReusableRecorder
        ref={reusableRecorderRef}
        onRecordingComplete={stableHandleRecordingComplete}
        onRecordingStart={handleRecordingStart}
        onRecordingStop={handleRecordingStop}
        maxDuration={40000}
        enableSpeechRecognition={true}
        fileName="retell-lecture.mp3"
      />

      <Col xs={12}>
        <h4 className="infoText"></h4>
      </Col>

      <Col xs={12}>
        <div className="col-lg-12 p-0 text-center">
          {!props.resultMode && (
            <div>
              <div
                className="currentStatus d-flex justify-content-center align-items-center p-0 audio-player-section"
              >
                <div className="w-100 text-white p-4">
                  <div className="d-flex justify-content-end w-100 align-items-center min-height-player-text">
                  {secondCount === 0 && blobURL === "" && !isRecording && (
                      <p className="mb-0 fs-10">{remainingTime}</p>
                    )}
                  </div>
                  <div className="d-flex justify-content-center align-content-center w-100 gap-3">
                    <i className="fa fa-play" aria-hidden="true"></i>
                    <div className="flex-grow-1">
                      <ProgressBar
                        style={{ backgroundColor: "#e9ecef", height: "15px" }}
                        barStyle={{ backgroundColor: "#4493e0" }}
                        now={soundPer}
                      />
                    </div>
                  </div>
                  <div className="d-flex justify-content-start w-100 align-items-center min-height-player-text">
                    {soundPer === 100 ? (
                      <p className="mb-0 fs-10 mx-4">Completed</p>
                    ) : soundStatus === true &&
                      secondCount !== 0 &&
                      !isRecording ? (
                      <p className="mb-0 fs-10 mx-4">
                        The clip will begin in {secondCount} seconds
                      </p>
                    ) : (
                      <p className="mb-0 fs-10 mx-4 invisible"></p>
                    )}
                  </div>
                  <br></br>
                  <div className="w-100 d-flex justify-content-center align-items-center">
                    <div className="d-flex justify-content-center gap-3  align-items-center w-50">
                      <i className="fa fa-volume-up" aria-hidden="true"></i>
                      <Form.Control
                        placeholder="Volume"
                        type="range"
                        min="0"
                        defaultValue={volume}
                        step="1"
                        onInput={(e) => changeRange(e)}
                        max="100"
                      />
                    </div>
                  </div>

                  <div className="d-flex justify-content-between">
                    <div className="stop-btn">
                      {!props.testMode &&
                        soundStatus === true &&
                        secondCount == 0 && (
                          <Button variant="success" onClick={stopAudio} size="sm">
                            Skip
                          </Button>
                        )}
                      {!props.testMode &&
                        secondCount !== 0 &&
                        blobURL === "" &&
                        !isRecording && (
                          <Button variant="success" onClick={skip} size="sm">
                            Skip
                          </Button>
                        )}
                    </div>
                    {!props.testMode && (
                      <div className="stop-btn">
                        <PlaybackSpeedBtns
                          changePlaybackSpeed={changePlaybackSpeed}
                          playbackSpeed={playbackSpeed}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="audio-box border-0 mock-resource-text">
                <p className="pl-3">
                  {" "}
                  {blobURL === "" && isRecording
                    ? "Recording started"
                    : ""}{" "}
                </p>

                <hr></hr>
                {!props.testMode && isRecording && (
                  <div className="stop-btn">
                    <Button variant="success" onClick={stopRecording} size="sm">
                      Stop
                    </Button>
                  </div>
                )}
                <hr></hr>
                <div
                  className="d-flex justify-content-start align-items-center gap-3"
                  style={{ minHeight: "60px" }}
                >
                  {isRecording ? (
                    <img
                      src={stopImage}
                      alt="Stop Recording"
                      style={{
                        height: "65px",
                        width: "65px",
                        objectFit: "contain",
                        display: "block",
                      }}
                    />
                  ) : (
                    <div className="d-flex justify-content-center align-items-center">
                      <img
                        src={grayImage}
                        alt="Not Recording"
                        style={{
                          height: "65px",
                          width: "65px",
                          objectFit: "contain",
                          display: "block",
                        }}
                      />
                      {secondCount2 > 0 && (
                        <p
                          className="text-center p-0 m-0"
                          style={{ fontSize: "20px" }}
                        >
                          Ready in {secondCount2}
                        </p>
                      )}
                    </div>
                  )}

                  <div
                    className="d-flex align-items-center flex-grow-1 mb-4"
                    style={{ height: "40px" }}
                  >
                    {/* Use recordCount * 2.5 for 40 seconds (40 * 2.5 = 100) */}
                    <MicWaveform
                      progressValue={recordCount * 2.5}
                      mockColor={"#0081A4"}
                      time={isRecording ? recordingTimeLeft : -1}
                    />
                  </div>
                </div>

                <div className="audo-line">
                  <span className="progress-bar-fill-Read intro"></span>
                </div>
              </div>
            </div>
          )}
          <Col xs={12}>
            {!props.resultMode &&
              props.data &&
              soundStatus &&
              secondCount === 0 && (
              isIOSDevice() ? (
                <IOSAudioPlayer
                  audioUrl={s3base + props.data.media_link}
                  onPlaying={handleSongPlaying}
                  onLoading={loadingSound}
                  onFinishedPlaying={handleSongFinishedPlaying}
                  volume={volume}
                  playbackRate={playbackSpeed}
                  soundKey={soundKey}
                />
                ):(
                  <Sound
                    url={s3base + props.data.media_link}
                    playStatus={Sound.status.PLAYING}
                    onPlaying={handleSongPlaying}
                    onLoading={loadingSound}
                    onFinishedPlaying={handleSongFinishedPlaying}
                    volume={volume}
                    playbackRate={playbackSpeed}
                    key={soundKey}
                    soundManagerConfig={{ debugMode: false }}
                  />
                )
              )}
          </Col>
          <Col xs={12}>
            {blobURL && !props.testMode && (
              <audio src={blobURL} controls="controls" />
            )}
          </Col>
        </div>
      </Col>
      <Col xs={12}>
        <h5>{questionText}</h5>
      </Col>
      {!isIOSDevice() && !props.resultMode && beepStatus && (
        <Sound
          // url={s3base + "/ptedata/ptemedia/beep.mp3"}
          url={Beep}
          playStatus={Sound.status.PLAYING}
          onFinishedPlaying={handleBeepFinishedPlaying}
          soundManagerConfig={{ debugMode: false }}
          onError={handleBeepFinishedPlaying}
        />
      )}
    </>
  );
};

export default RetellLec;